import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { ShopStatistic } from '../shop-statistic.model';

@JsonObject('ShopStatisticsResultsResponse')
export class ShopStatisticsResultsResponse extends ApiResultsResponse<ShopStatistic> {

  @JsonProperty('results', [ShopStatistic])
  override results: ShopStatistic[] = [];

  @JsonProperty('price_amount_percent_day_seven', Number, true)
  priceAmountPercentDaySeven: number = 0;

  @JsonProperty('price_amount_percent_day_thirty', Number, true)
  priceAmountPercentDayThirty: number = 0;

  @JsonProperty('price_amount_total_current_month', Number, true)
  priceAmountTotalCurrentMonth: number = 0;
}
